// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnBack_btn__17Syu","hidden":"BtnBack_hidden__MB7FX","arrow":"BtnBack_arrow__1r3oS","withText":"BtnBack_withText__PP2hn"};